import React from 'react';
import { Chip as MuiChip, type ChipProps } from '@mui/material';

export type { ChipProps };

export default function Chip(props: ChipProps) {
  return <MuiChip {...props} />;
}
